import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { guardarPushToken } from './api';

let isRegistered = false;

export async function registrarPushNotifications(navigate) {
  if (!Capacitor.isNativePlatform() || isRegistered) return;

  try {
    // Pedir permiso
    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive !== 'granted') {
      console.log('Push: permiso denegado');
      return;
    }

    // Registrar en FCM
    await PushNotifications.register();

    // Recibir token
    PushNotifications.addListener('registration', async (token) => {
      console.log('Push token:', token.value);
      try {
        const plataforma = Capacitor.getPlatform() === 'ios' ? 'ios' : 'android';
      await guardarPushToken(token.value, plataforma);
        isRegistered = true;
      } catch (e) {
        console.error('Error guardando push token:', e);
      }
    });

    // Error de registro
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // Notificacion recibida con app abierta
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push recibida:', notification);
    });

    // Click en notificacion
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const data = action.notification.data;
      if (navigate && data) {
        if (data.tipo === 'incidencia' && data.id) {
          navigate(`/incidencias/${data.id}`);
        } else if (data.tipo === 'anuncio' && data.id) {
          navigate(`/tablon/${data.id}`);
        }
      }
    });
  } catch (e) {
    console.error('Error registrando push:', e);
  }
}
